import '../styles/styles.css';

import React from 'react';
import { Helmet } from 'react-helmet';

import Evento from '../components/evento.component';
import eventos from '../data/eventos.data';
import { mainDescription, mainSubtitle, mainTitle, mainUrl } from '../data/main.data';
import cartaz from '../images/cartaz.jpg';
import favicon from '../images/favicon.jpg';
import logos from '../images/logos.jpg';

const IndexPage = () => {
  return (
    <main id="pontecoalusofonia" lang="gl">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {`${mainTitle} | ${mainSubtitle}: ${eventos.map(({ pais }) => pais).join(', ')}`}
        </title>
        <link rel="canonical" href={mainUrl} />
        <link rel="shortcut icon" href={favicon} />
        <meta name="description" content={mainDescription} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content={mainTitle} />
        <meta property="og:description" content={mainDescription} />
        <meta property="og:url" content={mainUrl} />
        <meta property="og:image" content={cartaz} />
        <meta property="og:image:alt" content={mainDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="gl_ES" />
        <meta property="og:site_name" content={mainTitle} />
        <meta name="twitter:title" content={mainTitle} />
        <meta name="twitter:description" content={mainDescription} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={cartaz} />
        <meta name="twitter:image:alt" content={mainDescription} />
        <meta name="twitter:site" content="@somosabella" />
        <meta name="twitter:creator" content="@somosabella" />
        <script
          defer
          src="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/js/all.min.js"
        />
      </Helmet>
      <header>
        <h1>
          <a href={mainUrl}>{mainTitle}</a>
        </h1>
        <h2>{mainSubtitle}</h2>
        <nav>
          <ul className="nav">
            {eventos.map(({ pais }) => (
              <li key={pais}>
                <a href={`#${pais}`}>{pais}</a>
              </li>
            ))}
          </ul>
        </nav>
      </header>
      <section className="presentacion">
        <div className="left">
          <h4>Unha selección polas cinematografías contemporáneas de países da comunidade lusófona</h4>
          <p>
            Unha Ponte coa Lusofonía é unha mostra de cinema lusófono, realizada na cidade de Vigo, España, desde o ano 2021. Este evento busca promover a diversidade cultural presente nos países de lingua portuguesa, incluíndo Brasil, Portugal, Galicia e demais países, a través do cinema.
          </p>
          <p>
            Ao longo de varias sesións de exhibición de filmes, buscamos estreitar lazos entre esas
            culturas, proporcionándolle ao público galego unha visión máis ampla das producións
            cinematográficas e artísticas desas rexións.
          </p>
          <p>
            O proxecto presenta unha selección diversificada e criteriosa de filmes que representan a riqueza cultural dos países lusófonos e de Galicia.
          </p>
        </div>
        <div className="right">
          <img src={cartaz} alt={mainDescription} />
        </div>
      </section>
      <section className="edicion">
        <p>A mostra Ponte coa Lusofonía chega á súa cuarta edición na cidade de Vigo, onde exhibiremos no mes de outubro filmes de Galicia, Portugal, Brasil e Guinea-Bissau. Amosaremos oito filmes, entre os cales hai tres estreas en España e unha estrea en Galicia. Os filmes foron proxectados nos principais festivais do mundo. Será unha oportunidade única para o público galego poder ter contacto coa máis recente cinematografía destes países.</p>
      </section>
      <section className="eventos">
        {eventos.map((evento) => (
          <Evento key={evento.data} evento={evento} />
        ))}
      </section>
      <section className="localizacion">
        <h1>Museo de Arte Contemporánea de Vigo (MARCO)</h1>
        <h4>
          <a href="https://maps.app.goo.gl/PkuG8XHWG8nG9Hxc6" target="_blank" rel="noopener noreferrer">
            <i className="fas fa-map-marker-alt" /> Rúa do Príncipe, 54, 36202 Vigo, Pontevedra, España
          </a>
        </h4>
        <p>
          A mostra celebrarase na sede do <a href="https://www.marcovigo.com/" target="_blank" rel="noopener noreferrer">
            Museo de Arte Contemporánea de Vigo (MARCO)
          </a>.
          Edificio de estilo ecléctico do arquitecto José María Ortiz. O proxecto remóntase a 1861, daquela o edificio foi concibido para albergar o antigo tribunal e a prisión.
        </p>
        <p>
          Este centro de arte fundado en 2002, creado para a divulgación de propostas culturais contemporáneas, basea a súa identidade no dinamismo da súa programación e no seu espírito participativo.
        </p>
        <p>
          O MARCO é a proposta máis vangardista da cidade, ofrecendo programas educativos dirixidos a alumnos, familias e cativos, así como programas de formación para artistas e profesores. O Museo dispón dunha biblioteca, dunha hemeroteca e dunha mediateca.
        </p>
      </section>
      <footer>
        <div className="logos">
          <img src={logos} alt="Colaboradores" />
        </div>
        <ul className="social">
          <li>
            <a href="https://www.facebook.com/somosabella" aria-label="Facebook">
              <i className="fab fa-facebook-square" title="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/somos.abella" aria-label="Instagram">
              <i className="fab fa-instagram-square" title="Instagram" />
            </a>
          </li>
        </ul>
        <h3>
          {`${mainTitle} | ${mainSubtitle} | ${mainDescription}`}
        </h3>
      </footer>
      <div className="nav-to-top">
        <a href="#pontecoalusofonia">⇧ Volver</a>
      </div>
    </main>
  );
};

export default IndexPage;